import UnauthorizedError from '../../components/errors/UnauthorizedError'

export default function AuthForm() {
  return <UnauthorizedError/>
}
